import { graphql } from '@/gql';
import type { PaginationInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchTeamLeads = async ({ pagination }: { pagination: PaginationInputType }) => {
  const response = await queryExecute({
    variables: {
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query TeamLeads($pagination: PaginationInputType) {
        teamLeads(pagination: $pagination) {
          count
          rows {
            id
            firstName
            lastName
            email
            phoneNumber
            textNumber
            language1
            language2
            workerSid
            departments
            slackId
            slackWebHook
            defaultType
            isDefaultOnly
            closedAt
            slingUserId
            isRehireEligible
          }
        }
      }
    `),
  });

  return response.data.teamLeads;
};
